module.exports = __webpack_public_path__ + "static/media/question.01671944.jpg";